/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function WallItemArAnchorStatusFromJSON(json) {
    return WallItemArAnchorStatusFromJSONTyped(json, false);
}
export function WallItemArAnchorStatusFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'anchorId': !exists(json, 'anchor_id') ? undefined : json['anchor_id'],
        'trackingStatus': !exists(json, 'tracking_status') ? undefined : json['tracking_status'],
        'anchorUpdatesProvider': !exists(json, 'anchor_updates_provider') ? undefined : json['anchor_updates_provider'],
    };
}
export function WallItemArAnchorStatusToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'anchor_id': value.anchorId,
        'tracking_status': value.trackingStatus,
        'anchor_updates_provider': value.anchorUpdatesProvider,
    };
}
/**
* @export
* @enum {string}
*/
export var WallItemArAnchorStatusTrackingStatus;
(function (WallItemArAnchorStatusTrackingStatus) {
    WallItemArAnchorStatusTrackingStatus["ERROR"] = "ANCHOR_TRACKING_STATUS_ERROR";
    WallItemArAnchorStatusTrackingStatus["INVALID"] = "ANCHOR_TRACKING_STATUS_INVALID";
    WallItemArAnchorStatusTrackingStatus["NORMAL"] = "ANCHOR_TRACKING_STATUS_NORMAL";
    WallItemArAnchorStatusTrackingStatus["PAUSED"] = "ANCHOR_TRACKING_STATUS_PAUSED";
    WallItemArAnchorStatusTrackingStatus["STOPPED"] = "ANCHOR_TRACKING_STATUS_STOPPED";
})(WallItemArAnchorStatusTrackingStatus || (WallItemArAnchorStatusTrackingStatus = {}));
/**
* @export
* @enum {string}
*/
export var WallItemArAnchorStatusAnchorUpdatesProvider;
(function (WallItemArAnchorStatusAnchorUpdatesProvider) {
    WallItemArAnchorStatusAnchorUpdatesProvider["DATATRACK"] = "STREAMING_MESSAGE_PROVIDER_DATA_TRACK";
    WallItemArAnchorStatusAnchorUpdatesProvider["INVALID"] = "STREAMING_MESSAGE_PROVIDER_INVALID";
    WallItemArAnchorStatusAnchorUpdatesProvider["TWILIOSYNCSTREAM"] = "STREAMING_MESSAGE_PROVIDER_TWILIO_SYNC_STREAM";
})(WallItemArAnchorStatusAnchorUpdatesProvider || (WallItemArAnchorStatusAnchorUpdatesProvider = {}));
//# sourceMappingURL=WallItemArAnchorStatus.js.map